import React from "react"
import * as classNames from "../SearchField.module.scss"
import Button from "../../../../blocks/button/Button"
import Icon from "../../../../blocks/icon/Icon"

function SearchField({ termFilter, setTermFilter, setSearchHistory }) {
  const handleSearch = () => {
    if (termFilter.trim() !== "") {
      setSearchHistory((prevHistory) => [...prevHistory, termFilter])
    }
    setTermFilter("")
  }

  return (
    <div className={`${classNames.searchField}`}>
      <label
        htmlFor="term"
        className="sr-only"
      >
        Tags
      </label>
      <input
        type="search"
        name="term"
        id="term"
        placeholder="Commercial"
        autoComplete="off"
        value={termFilter}
        onChange={(e) => setTermFilter(e.target.value)}
      />
      <Button
        aspect="unstyled"
        onClick={handleSearch}
      >
        <Icon
          icon="search"
          color="var(--gris)"
        />
      </Button>
    </div>
  )
}

export default SearchField
